"use client";
import * as React from "react";
const SvgStarOutlineRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m15.15 5.52-4.525-.385L8.86 1.057c-.318-.743-1.403-.743-1.72 0L5.372 5.145.857 5.52C.035 5.585-.302 6.593.324 7.124l3.43 2.915-1.027 4.326c-.187.788.682 1.412 1.392.99L8 13.063l3.879 2.301c.71.422 1.58-.202 1.393-.99l-1.029-4.335 3.43-2.915a.909.909 0 0 0-.523-1.604Zm-7.151 5.83-3.515 2.08.935-3.923-3.104-2.64L6.41 6.52l1.589-3.693L9.597 6.53l4.094.348-3.103 2.64.935 3.922-3.524-2.09Z" }));
export {
  SvgStarOutlineRound as default
};
